import { combineReducers } from "@reduxjs/toolkit";
import { connectRouter } from "connected-react-router";

import defaultModalsDataReducer from "./defaultModalsDataReducer";
//import authReducer from "./authReducer";
import compareReducer from "./compareReducer";
import messageReducer from "./messageReducer";

const reducers = (history) =>
  combineReducers({
    router: connectRouter(history),
    defaultModalsDataReducer,
    //authReducer,
    compareReducer,
    messageReducer,
  });

export default reducers;
